import React from "react";
import Plus from "sub_components/Common/Plus";
import Minus from "sub_components/Common/Minus";
import FullScreen from "sub_components/Common/Fullscreen";
import Print from "sub_components/Common/Print";
import Download from "sub_components/Common/Download";
import { Divider } from "styled_components/Common/Divider";

const CDN_URL = process.env.REACT_APP_CDN_URL;
const arrow = `${CDN_URL}common/down-nav-triangle-hover-lg.svg`;

const InvoiceControls = ({
  pdfZoom,
  zoom,
  goFull,
  invoice,
  supportParams,
  numPages,
  nextPage,
  pageNumber,
  previousPage,
}) => {
  // Internet Explorer 6-11
  const isIE = /*@cc_on!@*/ false || !!document.documentMode;
  // Edge 20+
  const isEdge = !isIE && !!window.StyleMedia;
  const windows = isIE || isEdge;

  return (
    <div className="invoice-controls">
      <Divider />
      <div className="invoice-controls-layout">
        <Plus width={20} pdfZoom={pdfZoom} />
        <div className="zoom">{zoom}%</div>
        <Minus width={20} pdfZoom={pdfZoom} />
        {pageNumber === numPages ? (
          <div className="changePage">
            <span className="previous-page" id="previousPage">
              {pageNumber === 1 && <img src={arrow} />}
              {pageNumber !== 1 && (
                <img onClick={() => previousPage()} src={arrow} />
              )}
            </span>
            {pageNumber} / {numPages}
            <span className="next-page" id="nextPage">
              <img src={arrow} />
            </span>
          </div>
        ) : (
          <div className="changePage">
            <span className="previous-page" id="previousPage">
              {pageNumber === 1 && <img src={arrow} />}
              {pageNumber !== 1 && (
                <img onClick={() => previousPage()} src={arrow} />
              )}
            </span>
            <span className="page-numbers">
              {pageNumber} / {numPages}
            </span>
            <span className="next-page" id="nextPage">
              <img onClick={() => nextPage()} src={arrow} />
            </span>
          </div>
        )}
        <FullScreen width={20} goFull={goFull} />
        {windows === false && (
          <Print
            width={20}
            invoice={invoice}
            invoiceId={supportParams?.invoiceId}
          />
        )}
        <Download
          width={20}
          downloadPdf={supportParams?.downloadPdf}
          invoiceId={supportParams?.invoiceId}
        />
      </div>
    </div>
  );
};

export default InvoiceControls;
